// // moment 语言包加载
// import 'moment/dist/locale/zh-cn';
// import 'moment/dist/locale/es';
// import 'moment/dist/locale/ja';
// import 'moment/dist/locale/fr.js';
// import 'moment/dist/locale/de';

export enum SupportedLanguages {
	'en-US' = 'en-US',
	'zh-CN' = 'zh-CN',
	'ru-RU' = 'ru-RU',
	'ja-JP' = 'ja-JP',
	'pt-BR' = 'pt-BR',
	'es-MX' = 'es-MX',
	'de-DE' = 'de-DE',
	'zh-TW' = 'zh-TW',
	'tr-TR' = 'tr-TR',
	'id-ID' = 'id-ID',
	'vi-VN' = 'vi-VN', //越南
	'th-TH' = 'th-TH', //泰国
	'ms-MY' = 'ms-MY', //马来西亚
	'hi-IN' = 'hi-IN', // 印度
	'ar-SA' = 'ar-SA', // 阿拉伯语
	'ko-KR' = 'ko-KR', //韩语
}

export const SUPPORTED_LANGUAGES_MAP_ROUTES: Record<string, SupportedLanguages> = {
	en: SupportedLanguages['en-US'],
	zh: SupportedLanguages['zh-CN'],
	'zh-tw': SupportedLanguages['zh-TW'],
	ru: SupportedLanguages['ru-RU'],
	ja: SupportedLanguages['ja-JP'],
	'pt-br': SupportedLanguages['pt-BR'],
	de: SupportedLanguages['de-DE'],
	tr: SupportedLanguages['tr-TR'],
	id: SupportedLanguages['id-ID'],
	'es-mx': SupportedLanguages['es-MX'],
	vi: SupportedLanguages['vi-VN'],
	th: SupportedLanguages['th-TH'],
	ms: SupportedLanguages['ms-MY'],
	'hi-in': SupportedLanguages['hi-IN'],
	ar: SupportedLanguages['ar-SA'],
	ko: SupportedLanguages['ko-KR'],
};

export const DEFAULT_LANGUAGE_ROUTE = 'en';

export const DEFAULT_LANGUAGE = SupportedLanguages['en-US'];

export const LOCALES_LIST = [
	{
		label: 'English(US)',
		value: SupportedLanguages['en-US'],
	},
	{
		label: '中文 (简体)',
		value: SupportedLanguages['zh-CN'],
	},
	{
		label: '中文 (繁體)',
		value: SupportedLanguages['zh-TW'],
	},
	{
		label: 'हिंदी', // 新印地
		value: SupportedLanguages['hi-IN'],
	},
	{
		label: 'Indonesia', //印度尼西亚
		value: SupportedLanguages['id-ID'],
	},
	{
		label: 'العربية', //阿拉伯语
		value: SupportedLanguages['ar-SA'],
	},
	{
		label: 'ภาษาไทย', //泰国
		value: SupportedLanguages['th-TH'],
	},
	{
		label: 'Bahasa Malay', //马来西亚
		value: SupportedLanguages['ms-MY'],
	},
	{
		label: '한국어', //韩语
		value: SupportedLanguages['ko-KR'],
	},
	{
		label: 'Tiếng Việt', //越南
		value: SupportedLanguages['vi-VN'],
	},
	{
		label: 'Türkçe', //土耳其语
		value: SupportedLanguages['tr-TR'],
	},
	{
		label: 'Português', //葡萄牙语，巴西
		value: SupportedLanguages['pt-BR'],
	},
	{
		label: 'Español', //西班牙语，墨西哥
		value: SupportedLanguages['es-MX'],
	},
	{
		label: 'Deutsch', //德语，德国
		value: SupportedLanguages['de-DE'],
	},
	{
		label: '日本語',
		value: SupportedLanguages['ja-JP'],
	},
	{
		label: 'Русский', //俄语
		value: SupportedLanguages['ru-RU'],
	},
];

export const localesTransMap = {
	'zh-CN': 'zh-CN',
	'zh-TW': 'zh-TW',
	'en-US': 'en-US',
	'ru-RU': 'ru-RU',
	'ja-JP': 'ja-JP',
	'pt-BR': 'pt-BR',
	'es-MX': 'es-MX',
	'de-DE': 'de-DE',
	'tr-TR': 'tr-TR',
	'id-ID': 'id-ID',
	'vi-VN': 'vi-VN', //越南
	'th-TH': 'th-TH', //泰国
	'ms-MY': 'ms-MY', //马来西亚
	'hi-IN': 'hi-IN', // 印度
	'ar-SA': 'ar-SA',
	'ko-KR': 'ko-KR', //韩语
};
export const unSupportedLanguages: string[] = [];
